import React, {Component} from 'react';
import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import {ToastContainer, ToastStore} from 'react-toasts';
import ClaimFormatterFunctions from './ClaimFormatters';
import Modal from 'react-responsive-modal';
import Claim from '../Claim/Claim';
import {SERVER_URL}  from '../Constants';
import Cookies from 'universal-cookie';



const { SearchBar } = Search;
const cookies = new Cookies();


const claimStadiumColumns = [
  { dataField: 'id', hidden:true, text: 'id', headerStyle: (colum, colIndex) => {return { width: '50px', textAlign: 'left' };}},
  { dataField: 'lastName', text: 'Name', classes:'text-primary', sort: true,formatter: ClaimFormatterFunctions.nameFormatter, textAlign: 'left'},
  { dataField: 'status', text: 'Stage',classes:ClaimFormatterFunctions.statusColFormaterClaims, formatter:ClaimFormatterFunctions.stageFormatter, filterable:true, sort: true, textAlign: 'left' },
  { dataField: 'claimDate', text: 'Claim Date',classes:'text-primary',formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: (colum, colIndex) => {return { width: '120px', textAlign: 'center' };} },
  { dataField: 'category', text: 'Category',sort: true, classes:'text-primary'},
  { dataField: 'subcat', text: 'Subcategory',sort: true, classes:'text-primary'},
  { dataField: 'brand', text: 'brand',sort: true, classes:'text-primary'},
  { dataField: 'color', text: 'color',sort: true, classes:'text-primary'},

  { dataField: 'details', text: 'Details',sort: true, },
  { dataField: 'section',sort: true, classes:'text-primary', text: 'section',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'row',sort: true, classes:'text-primary', text: 'row',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'seat',sort: true, classes:'text-primary', text: 'Seat',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'parkingLot',sort: true, classes:'text-primary', text: 'parkingLot',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},

];




function formatMatched(cell,row){
  try{
    if(row.totalMatches && row.totalMatches >0){
     // return(<a href='#' alt='Click here to see matched found items for this claim'><p className="text-info"><b>{row.totalMatches} Matched</b></p></a>)
     return (<button className="btn btn-outline-info btn-sm" type="button">{row.totalMatches} Matche(s)</button>)
    }else{
      return(null)
    }
    
  }catch(e){

  }
}

const paginationOption = {
  custom: true,
  sizePerPage: 100
};


 



class Claims extends Component {
  constructor(props) {
    super(props);
    
    //console.log(this.props.match.params.filter);
    let initialClaimFilter= cookies.get('initialClaimFilter');
    let defaultFilter = 'O';
    if (this.props.match.params.filter!==undefined){
      // use this if being called from another page and forcing the filter, i.e. Dashboard links
      defaultFilter = this.props.match.params.filter;
    }else if (initialClaimFilter!==undefined){
      // Carfeful!  This can be valid as "" signifying load all items.  only check for undefined.
      defaultFilter = initialClaimFilter;
    }

    // Get dimensions when the screen resizes
    window.addEventListener('resize', this.updateDimensions);
    //console.log(defaultFilter);


    console.log(defaultFilter);

    this.state = {
        claims: [],
        filteredClaims:[],
        isChecked: false,
        openCount:0,
        closedCountShipped:0,
        closedCountPickedUp:0,
        waitingToShipCount:0,
        WaitingForPickupCount:0,
        archivedCount:0,
        unlinkedCount:0,
        showNewClaim: false,
        allCount:0,
        labelRequested:0,
        initialFilter: defaultFilter,
        venueTypeCd :'',
        refreshButtonText: 'Refresh',
        selectedFilterLabel:'',
        statusFilter:'',
        width:window.width,
        height:window.height,
        
    };

    
    //cookies.set('initialClaimFilter', this.state.initialFilter, { path: '/' });
    this.rowEvents = {
        onClick: (e, row, rowIndex) => {
          //console.log(e.target.textContent);
          if (e.target.type==='button' && e.target.textContent==='View Item') {
            this.props.history.push('/LostItem/' + row.lostItemId );
            return;
          }
          if (e.target.type==='button') {
            this.props.history.push('/AIM/' + row.id );
            return;
          }
         

          this.props.history.push('/Claim/' + row.id);
          //console.log(this + ' ' + `clicked on row with index: ${rowIndex}`);
      
      
        },
        
      };
      axios.interceptors.response.use(response => {
        return response;
      }, error => {
       if (error.response.status === 401) {
        ToastStore.error("error unauthorized.  Your session has expired. Please log in again");
        
       }
       return error;
      });

  }

  async componentDidMount() {
    const venueTypeCd = auth0Client.getDefaultVenue().venueTypeCd;
    
    this.setState({
      venueTypeCd: venueTypeCd
    },this.refreshWithFilter())
    
    
    
    
  }
  
  updateDimensions = () => {
    this.setState({
       width: window.width, 
       height:window.height});
  };

  getClaimColumns=(venueTypeCd)=>{
    //console.log(venueTypeCd);
    if (venueTypeCd==='A'){
     return this.getClaimColumnsAirline();
     // airports
     //return this.getDefaultClaimColumns();
    }else if (venueTypeCd==='S'){
     return claimStadiumColumns;
    }else{
      return this.getDefaultClaimColumns();
    }
  }



  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}

    // new claims
  onOpenModal = () => {
    this.setState({ showNewClaim: true });
  };
 
  onCloseModal = () => {
    this.setState({ showNewClaim: false });
  };

  claim=()=>{
    
        /*this.setState({
          showNewClaim: true,
        })*/
        this.props.history.push('/Claim/-1');

    
  }


refreshWithFilter=()=>{
  this.setState({refreshButtonText:'Loading...'});
  let url ='';
  let filter = ( this.state.initialFilter)?  this.state.initialFilter : this.state.statusFilter;
   url = SERVER_URL+ '/Claims?statusFilter=' + filter;
   
  
  axios.get(url,{
    headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
  'venueId' : auth0Client.getActiveVenuedId()
  }
  }).then((res)=>{
    const claims  = res.data;
    if (claims){
       
        

      var openTotal = claims.filter(c => c.status === 'O').length;
      const csCount =  claims.filter(c => c.status === 'CS').length;
      const cpCount = claims.filter(c => c.status === 'CP').length;

      this.setState({
        claims: claims,
        allCount: claims.length,
        openCount:openTotal,
        closedCountShipped:csCount,
        closedCountPickedUp:cpCount,
        waitingToShipCount:claims.filter(c => c.status === 'READYTOSHIP').length,
        WaitingForPickupCount:claims.filter(c => c.status === 'WP').length,
        archivedCount:claims.filter(c => c.status === 'A').length,
        unlinkedCount:claims.filter(c => c.lostItemId === '').length,
        labelRequested: claims.filter(c => c.status === 'LABELREQUESTED').length,
        closedTotal: csCount+cpCount,
        filteredClaims:claims,
        selectedFilterLabel : this.getLabelFilterFromFilterCode (filter) + '(' + claims.length + ')'
      });
      if (this.props.updateOpenClaims) { this.props.updateOpenClaims(openTotal)}
      this.setState({refreshButtonText:'Refresh'});
    }
  }).catch((e)=>{
    this.setState({refreshButtonText:'Refresh'});
    ToastStore.error("An error occured. Please try again. Error:" + e.message);
  });
}


  refreshClaims=()=>{

    this.setState({refreshButtonText:'Loading...'});
    axios.get(`${SERVER_URL}/Claims`,{
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
    'venueId' : auth0Client.getActiveVenuedId()
    }
    }).then((res)=>{
      const claims  = res.data;
      if (claims){
         
          

        var openTotal = claims.filter(c => c.status === 'O').length;
        const csCount =  claims.filter(c => c.status === 'CS').length;
        const cpCount = claims.filter(c => c.status === 'CP').length;

        this.setState({
          claims: claims,
          allCount: claims.length,
          openCount:openTotal,
          closedCountShipped:csCount,
          closedCountPickedUp:cpCount,
          waitingToShipCount:claims.filter(c => c.status === 'READYTOSHIP').length,
          WaitingForPickupCount:claims.filter(c => c.status === 'WP').length,
          archivedCount:claims.filter(c => c.status === 'A').length,
          unlinkedCount:claims.filter(c => c.lostItemId === '').length,
          labelRequested: claims.filter(c => c.status === 'LABELREQUESTED').length,
          closedTotal: csCount+cpCount,
        }, ()=>{
            // all done setting everything, now apply the filer
            if (this.state.initialFilter){
              this.applyFilter(this.state.initialFilter);
            }
        });
        if (this.props.updateOpenClaims) { this.props.updateOpenClaims(openTotal)}
        this.setState({refreshButtonText:'Refresh'});
      }
    }).catch((e)=>{
      this.setState({refreshButtonText:'Refresh'});
      ToastStore.error("An error occured. Please try again. Error:" + e.message);
    });
    
  }

  //events:{onClick: (e, column, columnIndex, row, rowIndex) => { this.props.history.push('/Claim/' + row.id);}}

  getDefaultClaimColumns=()=>{
    //console.log('Loading Default Claims');

        const claimColumns = [
          { dataField: 'id', hidden:false,formatter:ClaimFormatterFunctions.formatId, text: 'id',style:{cursor: 'pointer', position:'sticky', left:0, zIndex:9, backgroundColor:'white'}, headerStyle:{ width: '110px', textAlign: 'left', classes:'text-secondary', position:'sticky', top:0,left:0, zIndex:9, backgroundColor:'white' }},
          { dataField: 'lastName', text: 'Name', sort: true,formatter: ClaimFormatterFunctions.formatName,style:{cursor: 'pointer'}, textAlign: 'left', headerStyle: { width: '200px', textAlign: 'center',position:'sticky', top:0, zIndex:1, backgroundColor:'white'  }},
          { dataField: 'status', text: 'Stage', formatter:ClaimFormatterFunctions.formatItemStatusCell, style:{cursor: 'pointer'},filterable:true, sort: true, textAlign: 'center', align:'center', headerStyle: { width: '170px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' } },
     
          { dataField: 'claimDate', text: 'Claim Date',classes:'text-primary',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: { width: '150px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          { dataField: 'details', text: 'Description',formatter:ClaimFormatterFunctions.formatlClaimDetailDescription,  style:{cursor: 'pointer', width: '270px'},sort: true,  headerStyle: { width: '350px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          { dataField: 'category',hidden:false, classes:'text-primary',style:{cursor: 'pointer'}, text: 'category',sort: true,headerStyle: { width: '150px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          { dataField: 'subcat', text: 'Subcategory',sort: true, classes:'text-primary', style:{cursor: 'pointer'}, headerStyle: { width: '150px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          { dataField: 'brand', hidden:false,classes:'text-primary',style:{cursor: 'pointer'}, text: 'brand',sort: true,headerStyle: { width: '100px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          { dataField: 'color', hidden:false,classes:'text-primary',style:{cursor: 'pointer'}, text: 'color',sort: true,headerStyle: { width: '100px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
  
          //{ dataField: 'lostItemShortDescription', text: 'Cat-color-brand',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatDescriptionBrandColor, sort: true,headerStyle:{width:'400px'} },
          { dataField: 'locationLost', classes:'text-primary', text: 'location', style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatLocation, sort: true,headerStyle: { width: '200px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          
          { dataField: 'updatedAt',hidden:true,  text: 'Updated On',classes:'text-primary',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: { width: '170px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          
          { dataField: 'notificationEmailSentDate', text: 'Notified',classes:'text-primary',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatDateTime, sort: true, headerStyle: { width: '190px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          { dataField: 'isReviewed', text: 'Reviewed?',classes:'text-primary  text-center',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatBoolean, sort: true, headerStyle: { width: '110px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          { dataField: 'reviewedAt', text: 'Reviewed On',classes:'text-primary text-center',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatDateTime, sort: true, headerStyle: { width: '180px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},

          { dataField: 'lostItemId', hidden:false,classes:'text-primary',align:'center', text: 'Found Item',sort: true, style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatFoundItemLink, headerStyle: { width: '150px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          { dataField: 'email', hidden:true, text: 'Email', sort: true, textAlign: 'left',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatEmail, headerStyle: {width: '200px', wordBreak: 'break-word', overflowWrap: 'break-word', wordWrap:'break-word', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }, },
          { dataField: 'registeredGuestName', text: 'Registered Name', sort: true,style:{cursor: 'pointer'}, textAlign: 'left',headerStyle: { width: '150px', textAlign: 'center' , position:'sticky', top:0, zIndex:1, backgroundColor:'white'} },
          { dataField: 'claimSource', hidden:false, text: 'Source', sort: true, textAlign: 'left',style:{cursor: 'pointer'}, headerStyle: {width: '100px', wordBreak: 'break-word', overflowWrap: 'break-word', wordWrap:'break-word', position:'sticky', left:0, zIndex:1, backgroundColor:'white' }, },

          // these are hidden but need to be searched:
          { dataField: 'firstName', hidden:true, text: 'Registered Name', sort: true,style:{cursor: 'pointer'},formatter: ClaimFormatterFunctions.formatName, textAlign: 'left', headerStyle: { width: '150px', textAlign: 'center', position:'sticky', top:0, zIndex:1, backgroundColor:'white' }},
          { dataField: 'totalMatches', classes:'text-primary text-center',style:{cursor: 'pointer'},formatter:formatMatched, text: 'Matched',sort: true,headerStyle:{width:'200px', cursor:'hand'}, events:{
            onClick: (e, column, columnIndex, row, rowIndex) => {
                  if (row.totalMatches && row.totalMatches > 0){
                   // this.props.history.push('/AIM/' + row.id );
                  }
            }}},
        ];
        //const claimColumns = [
        //  { dataField: 'id', hidden:false,formatter:ClaimFormatterFunctions.formatId, text: 'id',style:{cursor: 'pointer'}, headerStyle:{width:'200px', position:'sticky', top:0,left:0, zIndex:1, backgroundColor:'white', textAlign: 'left', classes:'text-secondary' }},
         
        //];
        return claimColumns;
  }
  getClaimColumnsAirline=()=>{


    const claimColumns = [
      { dataField: 'id', hidden:false,formatter:ClaimFormatterFunctions.formatId, text: 'id',style:{cursor: 'pointer'}, headerStyle:{ width: '120px', textAlign: 'left', classes:'text-secondary' }},
      { dataField: 'lastName', text: 'Name', sort: true,style:{cursor: 'pointer'},formatter: ClaimFormatterFunctions.formatName, textAlign: 'left', headerStyle: { width: '200px', textAlign: 'center' }},
      { dataField: 'status', text: 'Stage',style:{cursor: 'pointer'}, formatter:ClaimFormatterFunctions.formatItemStatusCell, filterable:true, sort: true, textAlign: 'center', align:'center', headerStyle: { width: '170px', textAlign: 'center' } },
      { dataField: 'claimDate', text: 'Claim Date',classes:'text-primary',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: { width: '150px', textAlign: 'center' }},
      { dataField: 'category',hidden:false, classes:'text-primary',style:{cursor: 'pointer'}, text: 'category',sort: true,headerStyle: { width: '150px', textAlign: 'center' }},
      { dataField: 'subcat', text: 'Subcategory',sort: true, classes:'text-primary', style:{cursor: 'pointer'}, headerStyle: { width: '150px', textAlign: 'center' }},
      { dataField: 'brand', hidden:false,classes:'text-primary',style:{cursor: 'pointer'}, text: 'brand',sort: true, headerStyle: { width: '100px', textAlign: 'center' }},
      { dataField: 'color', hidden:false,classes:'text-primary',style:{cursor: 'pointer'}, text: 'color',sort: true, headerStyle: { width: '100px', textAlign: 'center' }},
      { dataField: 'locationLost', classes:'text-primary', text: 'location Lost', style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatLocation, sort: true,headerStyle: { width: '250px', textAlign: 'center' }},

       { dataField: 'terminal',sort: true, hidden:false,classes:'text-primary', text: 'Terminal',  headerStyle: (colum, colIndex) => {return {   width: '150px',textAlign: 'center' };}},
      { dataField: 'gate',sort: true, hidden:false, classes:'text-primary', text: 'Gate / Lounge',  headerStyle: (colum, colIndex) => {return {   width: '150px',textAlign: 'center' };}},
  
     
      { dataField: 'updatedAt',hidden:true,  text: 'Updated On',style:{cursor: 'pointer'},classes:'text-primary',formatter:ClaimFormatterFunctions.formatDate, sort: true, headerStyle: { width: '170px', textAlign: 'center' }},
      
      { dataField: 'notificationEmailSentDate', text: 'Notified',style:{cursor: 'pointer'},classes:'text-primary',formatter:ClaimFormatterFunctions.formatDateTime, sort: true, headerStyle: { width: '190px', textAlign: 'center' }},
      { dataField: 'isReviewed', text: 'Reviewed?',classes:'text-primary  text-center',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatBoolean, sort: true, headerStyle: { width: '110px', textAlign: 'center' }},
      { dataField: 'reviewedAt', text: 'Reviewed On',classes:'text-primary text-center',style:{cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatDateTime, sort: true, headerStyle: { width: '180px', textAlign: 'center' }},

      { dataField: 'lostItemId', hidden:true,classes:'text-primary',style:{cursor: 'pointer'},align:'center', text: 'Found?',sort: true, formatter:ClaimFormatterFunctions.linked},
      { dataField: 'email', hidden:true, text: 'Email', sort: true, style:{cursor: 'pointer'},textAlign: 'left',formatter:ClaimFormatterFunctions.formatEmail, headerStyle: {width: '200px', wordBreak: 'break-word', overflowWrap: 'break-word', wordWrap:'break-word' }, },
    
      // these are hidden but need to be searched:
      { dataField: 'firstName', hidden:true, text: 'Name', sort: true,formatter: ClaimFormatterFunctions.formatName, textAlign: 'left', headerStyle: { width: '170px', textAlign: 'center' }},
      { dataField: 'flightNumber',sort: true, hidden:false,classes:'text-primary', text: 'Flight#',  headerStyle: (colum, colIndex) => {return {  textAlign: 'center', width: '150px' };}},
     
      { dataField: 'totalMatches', classes:'text-primary text-center',style:{cursor: 'pointer'},formatter:formatMatched, text: 'Matched',sort: true,headerStyle:{width:'150px', cursor:'hand'}, events:{
        onClick: (e, column, columnIndex, row, rowIndex) => {
              if (row.totalMatches && row.totalMatches > 0){
               // this.props.history.push('/AIM/' + row.id );
              }
        }}},
    ];
    
    return claimColumns;
}
  renderGrid=()=>{
    return (

      <div >
       
       {this.renderToast()}
   

        <ToolkitProvider 
        bootstrap4
          keyField='id' 
          data={ this.state.filteredClaims } 
          columns={ this.getClaimColumns(this.state.venueTypeCd) } 
        
         
          search
          >
          {
    props => (
      <div>
       
       
        <div className="row">
          <div className='col' >
              <button disabled={this.state.disabled || auth0Client.lfReadOnly===true} className="btn btn-success btn-sm " onClick={() => {this.claim()}}>
                  New Claim
              </button>
          </div>

          <div className='col' >
          <SearchBar { ...props.searchProps } />
          </div>
        <div className='col text-right'>
              {this.renderButtonFilterGroup()}
              <span style={{width:'5px'}}>     </span>
               <button className="btn btn-primary "  id="optArchive" onClick={this.refreshWithFilter} >{this.state.refreshButtonText}</button>

          </div>
        </div>
      <div style={{height:'1024px'}} >
        <BootstrapTable
         //className="table-sm"
          striped
          hover
          condensed
          rowEvents={this.rowEvents}
        //  headerStyle={ headerStyle }
          { ...props.baseProps }
          pagination={ paginationFactory(paginationOption) }
        />
        </div>
      </div>
    )
  }</ToolkitProvider>

      </div>


    )

    
  }

  getLabelFilterFromFilterCode=(filter)=>{
    let labelTitle = 'ALL';

      // set the label
      switch(filter){
      case 'ALL': labelTitle = 'ALL'; break;
      case 'READYTOSHIP': labelTitle = 'Ready To Ship'; break;
      case 'WP': labelTitle = 'Will Pickup'; break;
      case 'Closed': labelTitle = 'Closed'; break;
      case 'A': labelTitle = 'Archived'; break;
      case 'LABELREQUESTED': labelTitle = 'Label Requested'; break;
      case 'O': labelTitle = 'Open'; break;
      case 'REQUESTTOSHIP': labelTitle = 'Request To Ship'; break;
      
      default: labelTitle='ALL'
    }

    return labelTitle;
  }
  applyFilter=(filter)=>{
    
  
   if (cookies){
      //console.log('setting user cooke:' + filter);
      cookies.set('initialClaimFilter', filter, { path: '/' });
   }

    this.setState({
      statusFilter:filter,
      selectedFilterLabel: this.getLabelFilterFromFilterCode(filter),
      initialFilter:filter
    },()=>{
      this.refreshWithFilter()
    });

   
    /*let labelTitle = 'ALL';
    var filteredItems = null;
    if (filter==='All'){
      filteredItems = this.state.claims;
    }else if (filter==='Closed'){
      filteredItems = this.state.claims.filter((claimItem) =>{
        if (claimItem.status === 'CS' || claimItem.status === 'CP'){
          return claimItem;
        }else{ return null;}
      })
    }else {
      filteredItems = this.state.claims.filter((claimItem) =>{
       if (claimItem.status === filter){
         return claimItem;
       }else{ return null;}
     });
    }
     // set the label
     switch(filter){
        case 'ALL': labelTitle = 'ALL'; break;
        case 'READYTOSHIP': labelTitle = 'Ready To Ship'; break;
        case 'WP': labelTitle = 'Will Pickup'; break;
        case 'Closed': labelTitle = 'Closed'; break;
        case 'A': labelTitle = 'Archived'; break;
        case 'LABELREQUESTED': labelTitle = 'Label Requested'; break;
        case 'O': labelTitle = 'Open'; break;
        default: labelTitle='ALL'
     }


     labelTitle = labelTitle + "(" + filteredItems.length + ")";
     this.setState({
       initialFilter: filter,
       filteredClaims: filteredItems,
       selectedFilterLabel: labelTitle
     });*/




  }




  filterButtonClick=(event)=>{

    const target = event.target;
    
   
    var filter = 'O';
    switch(target.id){
      case 'optOpen': filter = 'O';  break;
      case 'optShip':filter = 'READYTOSHIP';  break;
      case 'optPickup':filter = 'WP';  break;
      case 'optClosed':filter = 'Closed'; break;
       case 'optArchived':filter = 'A';  break;
       case 'optLabelRequested':filter = 'LABELREQUESTED';  break;
      case 'optAll':filter = 'All'; break;
      case 'optRequestToShip':filter = 'REQUESTTOSHIP'; break;
      default: filter = 'O';


    }

    this.setState({
      statusFilter : filter
    })
    this.applyFilter(filter);

    
    return true;


  }

  renderButtonFilterGroup=()=>{
    return(
        <div className="btn-group text-right" role="group" aria-label="Button group with nested dropdown">
          <button type="button" className="btn btn-info ">Selected Filter:</button>
          <div className="btn-group" role="group">
            <button id="btnGroupDrop1" type="button" className="btn btn-info dropdown-toggle " data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{this.state.selectedFilterLabel}</button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1" >Seleted A Filter
               
                 <a className="dropdown-item" href="#/" id="optAll" onClick={this.filterButtonClick}>All </a>
                 <a className="dropdown-item" href="#/" id="optArchived" onClick={this.filterButtonClick}>Archived  </a>
                 <a className="dropdown-item" href="#/" id="optClosed" onClick={this.filterButtonClick}>Closed &amp; Returned</a>
                 <a className="dropdown-item" href="#/" id="optLabelRequested" onClick={this.filterButtonClick}>Label Requested</a>
                 <a className="dropdown-item" href="#/" id="optOpen" onClick={this.filterButtonClick}>Open </a>
                 <a className="dropdown-item" href="#/" id="optShip" onClick={this.filterButtonClick}>Ready to Ship </a>
                 <a className="dropdown-item" href="#/" id="optRequestToShip" onClick={this.filterButtonClick}>Request To Ship </a>
                 <a className="dropdown-item" href="#/" id="optPickup" onClick={this.filterButtonClick}>WILL Pickup </a>
  
            </div>
          </div>
        </div>
  
  
    )
  }
renderItemsToShipWarning=()=>{
  if (this.state.waitingToShipCount >0){
    return (
      <p className='text-danger'><b>There are {this.state.waitingToShipCount} items waiting to ship</b></p>
    )
  }
}

  render() {

    const { showNewClaim} = this.state;


    return (
  <div className="container-fluid">
      <div className="row">
          <div className='col-6' >
          <h4>Claim Management  </h4>
        </div>
        <div className='col-6 text-right' >
        {this.renderItemsToShipWarning()}
        </div>
      </div>
       
       <hr/>
       

       
          {
           this.renderGrid()
            }

           


             <Modal open={showNewClaim} onClose={this.onCloseModal}  center>
                <Claim lostItemId={this.state.id} isModalDisplay={true} refreshParent={this.refreshWithFilter}/>
            </Modal> 
        </div>
      
    )
  }
}

export default withRouter(Claims);